(() => {
  'use strict';
  document.querySelectorAll('[data-drawer-configurator]').forEach(product => {
    const dialog = product.querySelector('#fm-drawer-customise');
    const form = dialog?.querySelector('[data-drawer-form]');
    if (!dialog || !form) return;
    const groups = [...form.querySelectorAll('[data-drawer-group]')];
    const fields = [...form.querySelectorAll('[data-drawer-option]')];
    const familySelect = form.querySelector('[data-drawer-fabric-family]');
    const currentChoice = form.querySelector('[data-drawer-current-choice]');
    const productForm = product.querySelector('[data-product-form]');
    const storageProperty = productForm?.querySelector('[data-storage-property]');
    const colourProperty = productForm?.querySelector('[data-required-property="Colour"]');
    const key = 'fm-drawer-options-v1:' + product.dataset.productHandle;
    let opener;
    let state = {};

    try { state = JSON.parse(sessionStorage.getItem(key) || '{}'); } catch { state = {}; }
    fields.forEach(field => { if (state[field.name] === field.value) field.checked = true; });

    const filterFamilies = () => form.querySelectorAll('[data-drawer-fabric-group]').forEach(group => {
      group.hidden = familySelect.value !== 'all' && group.dataset.drawerFabricGroup !== familySelect.value;
    });
    const refresh = () => {
      groups.forEach(group => {
        const name = group.dataset.drawerGroup;
        const radio = group.querySelector('input:checked');
        if (!radio) return;
        state[name] = radio.value;
        product.querySelector(`[data-drawer-summary="${name}"]`).textContent = radio.value;
        if (name === 'colour') {
          const chip = radio.closest('label').querySelector('.fm-colour-chip');
          const icon = product.querySelector('[data-drawer-icon="colour"]');
          if (chip && icon) { icon.replaceChildren(chip.cloneNode(true)); icon.classList.add('has-colour'); }
        }
      });
      if (storageProperty) storageProperty.value = state.storage || '';
      if (colourProperty) colourProperty.value = state.colour || '';
      const selectedBase = form.querySelector('[data-drawer-group="storage"] input:checked');
      product.dataset.baseAddonVariantId = selectedBase?.dataset.addonVariantId || '';
      product.dataset.baseAddonPrice = selectedBase?.dataset.addonPrice || '0';
      const active = groups.find(group => !group.hidden);
      currentChoice.textContent = state[active?.dataset.drawerGroup] || 'Choose an option';
      product.dispatchEvent(new CustomEvent('fm:configuration-change'));
    };

    fields.forEach(field => field.addEventListener('change', () => {
      refresh();
      try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {}
    }));
    familySelect?.addEventListener('change', filterFamilies);
    form.addEventListener('submit', event => event.preventDefault());
    product.querySelectorAll('[data-drawer-open]').forEach(button => button.addEventListener('click', () => {
      opener = button;
      const name = button.dataset.drawerOpen;
      groups.forEach(group => { group.hidden = group.dataset.drawerGroup !== name; });
      const group = groups.find(item => !item.hidden);
      dialog.querySelector('h2').textContent = group.querySelector('legend').textContent;
      if (name === 'colour') {
        const selected = group.querySelector('input:checked');
        familySelect.value = selected?.closest('[data-drawer-fabric-group]')?.dataset.drawerFabricGroup || 'all';
        filterFamilies();
      }
      document.querySelectorAll('dialog[open]').forEach(openDialog => openDialog.close());
      dialog.showModal();
      refresh();
      (group.querySelector('input:checked') || group.querySelector('input'))?.focus({ preventScroll: true });
      dialog.scrollTop = 0;
    }));
    dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    refresh();
  });
})();

